import { useEffect, useState } from "react";
import { LegalShell, Section, Notice } from "@/components/legal/LegalShell";
import { getContent } from "@/lib/api";

export default function DynamicLegal({ pageKey }) {
  const [page, setPage] = useState(null);

  useEffect(() => {
    let active = true;
    getContent(pageKey).then((d) => { if (active) setPage(d); }).catch(() => {});
    return () => { active = false; };
  }, [pageKey]);

  if (!page) {
    return <div className="vault-bg"><div className="mx-auto max-w-4xl px-4 py-24 text-center text-slate-500">Načítavam…</div></div>;
  }

  return (
    <LegalShell eyebrow="Informácie" title={page.title} intro={page.intro}>
      {page.notice && <Notice>{page.notice}</Notice>}
      {(page.sections || []).map((s, i) => (
        <Section key={i} title={s.title}>
          {String(s.body || "").split("\n").filter(Boolean).map((para, j) => (
            <p key={j}>{para}</p>
          ))}
        </Section>
      ))}
    </LegalShell>
  );
}
